export const USER_TYPE = "mvp1";
export const USER_TYPE_MVP2 = "mvp2";

